import { render, staticRenderFns } from "./SettingModal.vue?vue&type=template&id=2d5f9516&scoped=true&"
import script from "./SettingModal.vue?vue&type=script&lang=js&"
export * from "./SettingModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingModal.vue?vue&type=style&index=0&id=2d5f9516&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5f9516",
  null
  
)

export default component.exports